// services/weatherService.ts
import { Location, WeatherData } from '../types/weather';

export const fetchWeatherData = async ({
  latitude,
  longitude,
}: Location): Promise<WeatherData> => {
  const response = await fetch(
    `https://api.open-meteo.com/v1/forecast?` +
      `latitude=${latitude}&longitude=${longitude}` +
      `&current=temperature_2m,relative_humidity_2m,apparent_temperature,precipitation,weather_code,wind_speed_10m` +
      `&hourly=temperature_2m,weather_code` +
      `&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_sum` +
      `&timezone=auto` +
      `&forecast_days=8`,
  );

  if (!response.ok) {
    throw new Error('Failed to fetch weather data');
  }

  return response.json();
};
